import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "projects/ProjetoBaseAngular/domain/services/base-crud.service";
import { MetaMsgTemplateComponentModel } from "../models";

@Injectable({
  providedIn: 'root'
})
export class MetaMsgTemplateComponentService extends BaseCrudService<MetaMsgTemplateComponentModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'MetaMsgTemplateComponent';
  }
}
